import { createStyles } from "@mantine/core";

export default createStyles ( ( theme, props ) => ( {
	notificationIconContainer: {
		display    : "flex",
		alignItems : "center",
		position   : "relative"
	},
	themeIcon: {
		height       : "2.8rem",
		width        : "2.8rem",
		cursor       : "pointer",
		// padding      : "0.5rem",
		background   : props?.open ? theme.other.colors.background2.primary : "none",
		borderRadius : props?.open ? "100%" : "none",

		"&:hover": {
			backgroundColor : theme.other.colors.background2.primary,
			borderRadius    : "100%"
		}
	},
	notificationCounter: {
		// width           : "5px",
		height          : "5px",
		backgroundColor : theme.other.paletteNew.tertiaryPink,
		borderRadius    : "1rem",
		padding         : "7px",
		fontSize        : "1rem",
		fontWeight      : "500",
		color           : "#fff",
		display         : "flex",
		alignItems      : "center",
		justifyContent  : "center",
		position        : "absolute",
		top             : "-11%",
		right           : "-28%"
	}
} ) );

